import { Component } from '@angular/core';
import { ProductCardComponent } from '../../components/product-card/product-card.component';
import { RelatedProductComponent } from '../../components/related-product/related-product.component';
import { CatalogsSelectorComponent } from '../../components/catalogs-selector/catalogs-selector.component';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { ContentService } from '../../services/content.service';
import { OffersInfoComponent } from '../../components/offers-info/offers-info.component';
import { CategoryService } from '../../services/category.service';
import { ProductService } from '../../services/product.service';

@Component({
  selector: 'app-shop',
  standalone: true,
  imports: [ProductCardComponent,
    RelatedProductComponent,
    CatalogsSelectorComponent,
    HeaderComponent,
    FooterComponent,
    OffersInfoComponent
  ],
  templateUrl: './shop.component.html',
  styleUrl: './shop.component.scss'
})
export class ShopComponent {
  catalogs: any[] = [];
  products: any[] = [];
  filterProducts: any[] = [];

  constructor(
    private categoryServices: CategoryService,
    private productService: ProductService
  ) {

  }

  ngOnInit() {
    this.categoryServices.getCategoriesShop().subscribe((res: any) => {
      this.catalogs = res;
    });

    this.productService.getProductByMainCategories().subscribe((res: any) => {
      this.products = res;
      this.filterProducts = res;
    });
  }

  getcategory(info: any) {
    if (info.categoria && info.subcategoria) {
      this.productService.getProductBysubCategories(info.subcategoria).subscribe((res: any) => {
        this.products = res;
      })
    } else {
      this.productService.getProductByMainCategories(info.categoria).subscribe((res: any) => {
        this.products = res;
      })
    }
  }

  searchProducts( evt: any) {
    if ( !evt?.target?.value ) {
      this.products = this.filterProducts;
    } else {
      this.products = this.filterProducts.filter((item:any) => item?.nombre?.toLowerCase().includes(evt?.target?.value.toLowerCase()) );
    }
  }
}
